type PText = {
  children: React.ReactNode;
  className?: string;
};

export default function Text({ children, className }: PText) {
  return <div className={className}>{children || ""}</div>;
}
